export default function APropos() {
  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl p-8 text-white shadow-lg">
        <h2 className="text-2xl font-bold mb-2">À propos de SUCCESSLINK AGENCY</h2>
        <p className="text-blue-100">Découvrez notre plateforme et notre mission</p>
      </div>

      <div className="bg-white rounded-xl p-8 shadow-lg">
        <div className="prose max-w-none">
          <h3 className="text-xl font-bold text-gray-800 mb-4">Notre Mission</h3>
          <p className="text-gray-700 mb-6">
            SUCCESSLINK AGENCY est une plateforme innovante qui permet à chacun de gagner de l'argent en accomplissant des tâches simples quotidiennes. Notre mission est de créer des opportunités de revenus accessibles à tous, partout dans le monde.
          </p>

          <h3 className="text-xl font-bold text-gray-800 mb-4">Comment ça marche ?</h3>
          <div className="space-y-4 mb-6">
            <div className="flex items-start">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                <span className="font-bold text-blue-600">1</span>
              </div>
              <div>
                <h4 className="font-semibold text-gray-800">Inscription gratuite</h4>
                <p className="text-gray-600 text-sm">Créez votre compte en quelques minutes</p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                <span className="font-bold text-blue-600">2</span>
              </div>
              <div>
                <h4 className="font-semibold text-gray-800">Accomplissez des tâches</h4>
                <p className="text-gray-600 text-sm">Regardez des vidéos, répondez à des questions, cliquez sur des publicités</p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                <span className="font-bold text-blue-600">3</span>
              </div>
              <div>
                <h4 className="font-semibold text-gray-800">Gagnez de l'argent</h4>
                <p className="text-gray-600 text-sm">Accumulez vos gains et retirez-les quand vous voulez</p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                <span className="font-bold text-blue-600">4</span>
              </div>
              <div>
                <h4 className="font-semibold text-gray-800">Parrainez vos amis</h4>
                <p className="text-gray-600 text-sm">Gagnez des bonus sur 3 niveaux de parrainage</p>
              </div>
            </div>
          </div>

          <h3 className="text-xl font-bold text-gray-800 mb-4">Système de parrainage</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div className="bg-blue-50 rounded-lg p-4 text-center">
              <p className="text-sm text-gray-600 mb-1">Niveau 1</p>
              <p className="text-2xl font-bold text-blue-600">1 500 FCFA</p>
              <p className="text-xs text-gray-500 mt-1">Par filleul direct activé</p>
            </div>
            <div className="bg-green-50 rounded-lg p-4 text-center">
              <p className="text-sm text-gray-600 mb-1">Niveau 2</p>
              <p className="text-2xl font-bold text-green-600">600 FCFA</p>
              <p className="text-xs text-gray-500 mt-1">Par filleul de niveau 2 activé</p>
            </div>
            <div className="bg-orange-50 rounded-lg p-4 text-center">
              <p className="text-sm text-gray-600 mb-1">Niveau 3</p>
              <p className="text-2xl font-bold text-orange-600">400 FCFA</p>
              <p className="text-xs text-gray-500 mt-1">Par filleul de niveau 3 activé</p>
            </div>
          </div>

          <h3 className="text-xl font-bold text-gray-800 mb-4">Nos Avantages</h3>
          <ul className="space-y-2 mb-6">
            <li className="flex items-start">
              <i className="ri-checkbox-circle-fill text-green-500 mr-2 mt-0.5"></i>
              <span className="text-gray-700">Paiements rapides et sécurisés</span>
            </li>
            <li className="flex items-start">
              <i className="ri-checkbox-circle-fill text-green-500 mr-2 mt-0.5"></i>
              <span className="text-gray-700">Tâches simples et accessibles à tous</span>
            </li>
            <li className="flex items-start">
              <i className="ri-checkbox-circle-fill text-green-500 mr-2 mt-0.5"></i>
              <span className="text-gray-700">Support client disponible 24/7</span>
            </li>
            <li className="flex items-start">
              <i className="ri-checkbox-circle-fill text-green-500 mr-2 mt-0.5"></i>
              <span className="text-gray-700">Formations gratuites en Trading et E-Commerce</span>
            </li>
            <li className="flex items-start">
              <i className="ri-checkbox-circle-fill text-green-500 mr-2 mt-0.5"></i>
              <span className="text-gray-700">Roue de chance pour gagner des bonus</span>
            </li>
          </ul>

          <h3 className="text-xl font-bold text-gray-800 mb-4">Besoin d'aide ?</h3>
          <p className="text-gray-700 mb-4">
            Notre service client est là pour vous aider ! Posez vos questions et recevez des réponses rapides de notre équipe.
          </p>
          
          <a
            href="#service-client"
            onClick={(e) => {
              e.preventDefault();
              const event = new CustomEvent('changeSection', { detail: 'service-client' });
              window.dispatchEvent(event);
            }}
            className="inline-flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-teal-500 to-teal-600 text-white rounded-lg hover:shadow-lg transition whitespace-nowrap cursor-pointer font-semibold mb-6"
          >
            <i className="ri-customer-service-2-line text-xl"></i>
            <span>Contacter le Service Client</span>
          </a>

          <h3 className="text-xl font-bold text-gray-800 mb-4">Rejoignez notre communauté</h3>
          <p className="text-gray-700 mb-4">
            Restez connecté avec nous et ne manquez aucune actualité ! Rejoignez notre chaîne WhatsApp et notre groupe Telegram pour recevoir des notifications, des conseils et échanger avec la communauté.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 mb-6">
            <a
              href="https://whatsapp.com/channel/0029VbCEuEA1NCrMAsPILy3J"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center space-x-3 px-6 py-4 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg hover:shadow-lg transition whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              <span className="font-semibold">Rejoindre la chaîne WhatsApp</span>
            </a>
            
            <a
              href="https://t.me/+RLed8IfVgMINDg0"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center space-x-3 px-6 py-4 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:shadow-lg transition whitespace-nowrap cursor-pointer"
            >
              <i className="ri-telegram-line text-2xl"></i>
              <span className="font-semibold">Rejoindre le groupe Telegram</span>
            </a>
          </div>

          <h3 className="text-xl font-bold text-gray-800 mb-4">Contact</h3>
          <p className="text-gray-700">
            Pour toute question ou assistance, n'hésitez pas à nous contacter via WhatsApp, Telegram ou par email. Notre équipe est là pour vous aider !
          </p>
        </div>
      </div>
    </div>
  );
}